export const environment = {
  production: true,
  languages: ['en', 'fr', 'id'],
  defaultLang: 'en',
  title: '4D',
  favicon: '/static/images/favicon/4Dfav.ico',
  ws: {
    key: 'app-key',
    enabledTransports: ['wss'],
    authEndpoint: '/broadcasting/auth',
  }
};
